import * as rest from './RestUtil';
import * as storage from '../util/StorageUtil';
import { getFunctionBaseUrl } from './RestUrls';
import { IPomReportCategoryData } from '../util/DataModelInterface';

const comparer = (a: any, b: any) => {
  return a.code.localeCompare(b.code);
}

export const getCategories = async (force: boolean = false) => {
  let categories = storage.getCategories();
  if (!categories || force) {
    const url = `${getFunctionBaseUrl()}/api/categoriesGet/`;
    const response = await rest.get(url);
    if (response.result) {
      let sortedCat = response.result.cat.sort(comparer);
      categories = sortedCat;
      if (categories) {
        storage.setCategories(categories);
        return categories;
      }
    } else {
      return response;
    }
  }
  return categories;
}

export const modifyCategory = async (category: IPomReportCategoryData) => {
  const url = `${getFunctionBaseUrl()}/api/categoryInsert/`;
  const response = await rest.post(url, category);
  console.log("resp: ", response);
  return response;
}

export const getReport = async (id: string, period: string) => {
  const url = `${getFunctionBaseUrl()}/api/pomReportGet/${period}/${id}`;
  const response = await rest.get(url);
  return response;
}

export const getReports = async (periodStart: string, periodEnd: string, id: string) => {
  const url = `${getFunctionBaseUrl()}/api/pomReportsGet/${periodStart}/${periodEnd}/${id}`;
  const response = await rest.get(url);
  return response;
}

export const setReportStatus = async (id: string, status: string, user_name: string) => {
  const url = `${getFunctionBaseUrl()}/api/pomReportSetStatus/${id}/${status}/${user_name}`;
  const response = await rest.get(url);
  return response;
}

export const postReport = async (period: string, data: any) => {
  const url = `${getFunctionBaseUrl()}/api/pomReportInsert/${period}`;
  const response = await rest.post(url, data);
  return response;
}

export const exportReport = async (data: any) => {
  const url = `${getFunctionBaseUrl()}/api/exportReport/`;
  const response = await rest.exporting(url, data);
  return response;
}

export const getReportStatus = async (ids: number[], period = "null") => {
  const url = `${getFunctionBaseUrl()}/api/reportStatusGet/${period}/${ids}`;
  const response = await rest.get(url);  
  return response;
}

export const getReportedPom = async (periodStart: string, periodEnd: string, category: string) => {
  const url = `${getFunctionBaseUrl()}/api/reportedPomGet/${periodStart}/${periodEnd}/${category}`;
  const response = await rest.get(url);  
  return response;
}